import { render, staticRenderFns } from "./GenerateCertificated.vue?vue&type=template&id=cd824d9c&scoped=true&"
import script from "./GenerateCertificated.vue?vue&type=script&lang=js&"
export * from "./GenerateCertificated.vue?vue&type=script&lang=js&"
import style0 from "./GenerateCertificated.vue?vue&type=style&index=0&id=cd824d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd824d9c",
  null
  
)

export default component.exports